import axios from "axios";
import { useState } from "react";
import { Button, Card, Col, Form, Row } from "react-bootstrap";
import { useHistory, useParams } from "react-router-dom/cjs/react-router-dom.min";
import { validateAddressForm } from "../../utils/validation";
import statesCities from "../StateCitiesJson/statesCities.json";
import CommonToast from "../Toaster/CommonToast";
import CommonLoader from "../loaderComponent/CommonLoader";
const CommonDetailsForm = ({ useType = null, data, onClose }) => {

  const { type, id } = useParams();
  const [cities, setCities] = useState([]);
  const history = useHistory();
  const [formData, setFormData] = useState({
    address: "",
    pincode: "",
    state: "",
    state_code: "",
    city: "",
    area: '',
    addressType: "",
    type: type,
    entityId: id
  });
  const [errors, setErrors] = useState({});
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastVariant, setToastVariant] = useState("");
  const [color, setColor] = useState("");
  const [loading, setLoading] = useState(false);
  const handleBack = () => {
    if (type === "c") {
      history.push("/customer-list");
    } else {
      history.push("/vendor-list");
    }
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    let newErrors = { ...errors };
    if (value.trim()) {
      delete newErrors[name];
    } else {
      newErrors[name] = `${name.charAt(0).toUpperCase() + name.slice(1)} is required`;
    }
    setFormData((prevData) => ({ ...prevData, [name]: value }));
    setErrors(newErrors);
  };

  const handleStateChange = (e) => {
    const selectedState = e.target.value;
    let newErrors = { ...errors };

    if (selectedState) {
      delete newErrors.state;
    }

    setFormData({ ...formData, state: selectedState, city: "" });
    setCities(statesCities[selectedState] || []);
    setErrors(newErrors);
  };

  const handleSubmit = async (e) => {
    setLoading(true)
    e.preventDefault();
    const validationErrors = validateAddressForm(formData);
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      setLoading(false);
      return;
    }
    try {
      const payload = { ...formData };
      await axios.post("/address/create", payload);
      setToastMessage("Address added!");
      setToastVariant("success");
      setColor("green");
      setShowToast(true);
      setTimeout(() => {
        if (onClose) onClose();
        setLoading(false)
        history.push(type === 'c' ? '/customer-list' : '/vendor-list');
      }, 900);
    } catch (error) {
      console.log("Error saving address:")
      console.error("Error saving address:", error);
      setToastMessage("Error adding address");
      setToastVariant("danger");
      setColor("red");
      setShowToast(true);
    }
    setTimeout(() => {
      setLoading(false);
      setShowToast(false);
    }, 900);
  };

  return (
    <div className="pt-4">
      <CommonToast
        show={showToast}
        onClose={() => setShowToast(false)}
        message={toastMessage}
        variant={toastVariant}
        color={color}
      />

      <CommonLoader isLoading={loading}>
        <>
          <Card className="shadow-sm rounded border-0">
            <Card.Header className="text-white">
              <b>{type === "c" ? "Customer" : "Vendor"} Address Details</b>
            </Card.Header>
            <Card.Body>
              <Form onSubmit={handleSubmit}>
                <Row className="mb-3">
                  <Col xs={12} md={4} lg={4}>
                    <Form.Group>
                      <Form.Label className="required">Address</Form.Label>
                      <Form.Control
                        as="textarea" name="address"
                        rows={1} value={formData.address} onChange={handleChange} placeholder="Enter address" />
                    </Form.Group>
                    <span className="login-error">
                      {errors.address && <small className="text-danger">{errors.address}</small>}
                    </span>
                  </Col>

                  <Col xs={12} md={3} lg={3}>
                    <Form.Group>
                      <Form.Label className="required">State</Form.Label>
                      <Form.Control as="select" className="form-select" name="state" value={formData.state} onChange={handleStateChange} >
                        <option value="">Select state</option>
                        {Object.keys(statesCities).map((state) => (
                          <option key={state} value={state}>
                            {state}
                          </option>
                        ))}
                      </Form.Control>
                    </Form.Group>
                    <span className="login-error">
                      {errors.state && <small className="text-danger">{errors.state}</small>}
                    </span>
                  </Col>
                  <Col xs={12} md={2} lg={2}>
                    <Form.Group>
                      <Form.Label className="required">City</Form.Label>
                      <Form.Control as="select" className="form-select" name="city" value={formData.city} onChange={handleChange} >
                        <option value="">Select city</option>
                        {cities.map((city) => (
                          <option key={city} value={city}>
                            {city}
                          </option>
                        ))}
                      </Form.Control>
                    </Form.Group>
                    <span className="login-error">
                      {errors.city && <small className="text-danger">{errors.city}</small>}
                    </span>
                  </Col>
                  <Col xs={12} md={3} lg={3}>
                    <Form.Group>
                      <Form.Label className="">Area</Form.Label>
                      <Form.Control type="text" name="area" value={formData.area}
                        onChange={handleChange}
                        placeholder="Enter area" />
                    </Form.Group>
                  </Col>
                </Row>

                <Row className="mb-3">
                  <Col xs={12} md={2} lg={2}>
                    <Form.Group>
                      <Form.Label className="required">Pin Code</Form.Label>
                      <Form.Control type="text" name="pincode" value={formData.pincode}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (/^\d{0,6}$/.test(value)) {
                            handleChange(e);
                          }
                        }}
                        pattern="\d{6}"
                        maxLength={6}

                        placeholder="Enter pincode" />
                    </Form.Group>
                    <span className="login-error">
                      {errors.pincode && <small className="text-danger">{errors.pincode}</small>}
                    </span>
                  </Col>
                  <Col xs={12} md={2} lg={2}>
                    <Form.Group>
                      <Form.Label className="required">State Code</Form.Label>
                      <Form.Control type="text" name="state_code" value={formData.state_code}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (/^\d{0,2}$/.test(value)) {
                            handleChange(e);
                          }
                        }}
                        pattern="\d{2}"
                        maxLength={2}

                        placeholder="Enter state code" />
                    </Form.Group>
                    <span className="login-error">
                      {errors.state_code && <small className="text-danger">{errors.state_code}</small>}
                    </span>
                  </Col>

                  <Col xs={12} md={3} lg={3}>
                    <Form.Group>
                      <Form.Label className="required">Type</Form.Label>
                      <Form.Control type="text" name="type" value={type === 'c' ? "Customer" : 'Vendor'} readOnly />
                    </Form.Group>
                  </Col>
                  <Col xs={12} md={5} lg={5}>
                    <Form.Group>
                      <Form.Label className="required">Address Type</Form.Label>
                      <div className="d-flex gap-4 border rounded p-1 bg-light">
                        <Form.Check
                          type="radio"
                          label="Dispatch"
                          name="addressType"
                          value="d"
                          checked={formData.addressType === "d"}
                          onChange={handleChange}

                        />
                        <Form.Check
                          type="radio"
                          label="Billing"
                          name="addressType"
                          value="b"
                          checked={formData.addressType === "b"}
                          onChange={handleChange}

                        />
                      </div>
                    </Form.Group>
                    <span className="login-error">
                      {errors.addressType && <small className="text-danger">{errors.addressType}</small>}
                    </span>
                  </Col>
                </Row>              {/* City Dropdown */}
                <div className="add-cancel-btn">
                  <Button type="submit" variant='primary' className="d-flex align-items-center gap-2 px-4 py-2 rounded-pill shadow-sm custom-add-button btn btn-primary">Save</Button>
                  <Button variant='danger' className="d-flex align-items-center gap-2 px-4 py-2 rounded-pill shadow-sm custom-add-button-cancel" onClick={handleBack}>Cancel</Button>
                </div>
              </Form>
            </Card.Body>
          </Card>
        </>
      </CommonLoader>
    </div>
  );
};

export default CommonDetailsForm;
